// frontend/src/GothamPostGameCount/apiClient.js — thin wrapper around authenticatedFetch for /api/gotham-post-game-count
// (same shape as GothamPosProducts/apiClient.js).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/gotham-post-game-count';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const post = (path, body) => authenticatedFetch(`${BASE}${path}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
});

export const gpgcApi = {
  sheet: (gameDate) => authenticatedFetch(`${BASE}/sheet${gameDate ? `?game_date=${gameDate}` : ''}`).then(jsonOrThrow),
  apply: (gameDate, lines) => post('/apply', { game_date: gameDate || null, lines }).then(jsonOrThrow),
  uploaded: (body) => post('/uploaded', body).then(jsonOrThrow),
  readXlsx: (file) => {
    const fd = new FormData(); fd.append('file', file);
    return authenticatedFetch(`${BASE}/read-xlsx`, { method: 'POST', body: fd }).then(jsonOrThrow);
  },
  exportFile: async (gameDate, format, counts, blank = false) => {
    const r = await post('/export', { game_date: gameDate || null, format, counts, blank });
    if (!r.ok) await jsonOrThrow(r);
    const name = (/filename="([^"]+)"/.exec(r.headers.get('Content-Disposition') || '') || [])[1] || `gotham-fc-post-game-count.${format}`;
    return { blob: await r.blob(), name };
  },
};
